/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type CampaignPeriodCampaignPeriodEnum =
  (typeof CampaignPeriodCampaignPeriodEnum)[keyof typeof CampaignPeriodCampaignPeriodEnum];

export const CampaignPeriodCampaignPeriodEnum = {
  until_cancel: "until_cancel",
  one_time: "one_time",
  date_specific: "date_specific",
} as const;
